import React, { useEffect } from 'react'
import { motion } from 'framer-motion'
import Topbar from '../../components/Bar/Topbar'
import Header from '../../components/Bar/Header'
import Footer from '../../components/Footer/Footer'

import BannerArea from '../../components/Carousel/BannerArea'
import MainContainer from '../../components/Carousel/MainContainer'
import MainContainer2 from '../../components/Carousel/MainContainer2'
import FeaturesSection from '../../components/Sections/FeaturesSection'
import MainContainer3 from '../../components/Carousel/MainContainer3'

const About = () => {
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 2, ease: 'easeOut' }}
    >

      <Header />
      <BannerArea />

     
      <MainContainer2 />
      <FeaturesSection/>
  
     
      <Footer />
    </motion.div>
  )
}

export default About
